import { Card, Col, Row } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { TableHeadOption } from "../../../../Constant";
import { TABLEHEAD_OPTION, TABLEHEAD_OPTION_BODY, TABLEHEAD_OPTION_HEAD } from "../../../../Data/BootstrapTable/BasicTable";

export default function TableHeadOptions() {
  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={TableHeadOption} span={TABLEHEAD_OPTION} table/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable headClass="table-dark" headData={TABLEHEAD_OPTION_HEAD}>
              {TABLEHEAD_OPTION_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.firstName}</td>
                  <td>{data.lastName}</td>
                  <td>{data.userName}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
